import {Tooltip} from 'platform/components';
import {Icon} from 'platform/foundation-tw';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getTooltipProps} from '../../utils/getTooltipProps';

type CheckboxCellRendererProps = CellRendererProps<boolean | null> & {
  getTooltipProps?: TooltipGetter;
};

export function CheckboxCellRenderer(props: CheckboxCellRendererProps) {
  if (isNil(props.value)) {
    return null;
  }

  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);

  return (
    <Tooltip {...tooltipProps}>
      <span style={{display: 'inline-flex'}}>
        {match(props.value)
          .with(true, () => <Icon value="action/check_circle" size={6} color="severity.success" />)
          .with(false, () => <Icon value="navigation/cancel" size={6} color="severity.danger" />)
          .exhaustive()}
      </span>
    </Tooltip>
  );
}
